import React from "react";

const ROLES = [
  { number: 1, label: "Innovator" },
  { number: 2, label: "Expert" },
  { number: 3, label: "Facility Centre" },
  { number: 4, label: "Manufacturer" },
  { number: 5, label: "Patent / IP" },
  { number: 6, label: "Investor / Funding" },
  { number: 7, label: "Government Support" },
  { number: 8, label: "Market" },
  { number: 9, label: "Mass Production" },
  { number: 10, label: "Employment & Growth" },
];

function RoleCard({ number, label }) {
  return (
    <div
      style={{
        background:
          "linear-gradient(160deg, #EAF3FC 0%, #F6FAFE 55%, #EFF6FC 100%)",
        border: "1px solid #DCE7F3",
        borderRadius: "16px",
        padding: "28px 20px",
        textAlign: "center",
      }}
    >
      <div
        style={{
          width: "38px",
          height: "38px",
          borderRadius: "50%",
          background: "#0B1F3A",
          color: "#FFFFFF",
          fontSize: "15px",
          fontWeight: 700,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "0 auto 18px auto",
        }}
      >
        {number}
      </div>
      <div
        style={{
          fontSize: "16px",
          fontWeight: 700,
          color: "#0B1F3A",
        }}
      >
        {label}
      </div>
    </div>
  );
}

export default function EcosystemSection() {
  return (
    <section
      style={{
        background: "#FFFFFF",
        padding: "80px 24px",
        fontFamily:
          "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      }}
    >
      <div style={{ maxWidth: "1180px", margin: "0 auto" }}>
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "52px" }}>
          <span
            style={{
              display: "inline-block",
              fontSize: "13px",
              fontWeight: 700,
              letterSpacing: "1.5px",
              color: "#7f47ec",
              marginBottom: "14px",
              textTransform: "uppercase",
            }}
          >
            The Ecosystem
          </span>
          <h2
            style={{
              fontSize: "44px",
              fontWeight: 800,
              color: "#0B1F3A",
              margin: 0,
              lineHeight: 1.25,
            }}
          >
            Everyone Has a Role
            <br />
            in <span style={{ color: "#7f47ec" }}>Building the Future.</span>
          </h2>
        </div>

        {/* Grid */}
        <div
          className="eco-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(5, 1fr)",
            gap: "18px",
          }}
        >
          {ROLES.map((role) => (
            <RoleCard key={role.number} number={role.number} label={role.label} />
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 1024px) {
          .eco-grid {
            grid-template-columns: repeat(3, 1fr) !important;
          }
        }
        @media (max-width: 640px) {
          .eco-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }
          h2 {
            font-size: 32px !important;
          }
        }
      `}</style>
    </section>
  );
}